export { IncidentProperties } from './IncidentProperties';
